import { fetchProfiles } from '@/core/fetch-profiles';
import { resolveActiveProfile } from '@/core/resolve-active-profile';
import { PL_LOG_GROUPS, logger } from '@/utils';
import { LOG_LEVEL } from '@b2x/shared';
import type { StoreControls } from './profiles-store';

function setActiveProfile({ setState }: StoreControls, profileId: string) {
  setState((prevState) => {
    const activeProfile = prevState.availableProfiles.find((profile) => profile.id === profileId);
    if (!activeProfile) {
      return prevState;
    }
    return { activeProfile };
  });
}

export async function refetchProfiles({ setState }: StoreControls) {
  logger('Refetching profiles', {
    group: PL_LOG_GROUPS.CORE,
    level: LOG_LEVEL.INFO,
  });
  const { profiles, meta } = await fetchProfiles();
  const activeProfile = await resolveActiveProfile(profiles);
  const availableProfiles = profiles.length > 0 ? profiles : [activeProfile];

  const updatedProfilesState = {
    activeProfile,
    availableProfiles,
    meta,
  };

  setState(updatedProfilesState);
  logger('Updated profiles state', {
    args: [updatedProfilesState],
    group: PL_LOG_GROUPS.CORE,
    level: LOG_LEVEL.INFO,
  });
}

export const api = {
  setActiveProfile,
  refetchProfiles,
};
